import { Box, Button, Card, CircularProgress, FormControl, Grid, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { Helpers } from '../../../services/Helpers';
import { AddToPhotos, Refresh } from '@mui/icons-material';
import { PaymentServices } from '../../Payment/Booking/BookingPaymentServices';
import ImgUploadDialog from '../../../components/ImgUpload/imgUpload';
import Swal from 'sweetalert2';

const AddPaymentRecord = (props) => {
  const {bookingDetails,closePaymentEntryDialog,fetchBookingDetalById} = props;
  const initialState = {
    bookingId : '',
    bookingNumber:'',
    bookingAmount:'',
    bookingBalanceAmount : '', // Outstanding balance at time of payment
    customerPaidAmount : '', // Amount customer actually paid
    image : '',
    paymentMethod : 'CASH', // ENUM('CASH', 'UPI_QR', 'APP_RAZORPAY')
    expertPaymentStatus : 'NOT_TRANSFERRED', // ENUM( 'TRANSFERRED_FULL', 'PAID_FEES_ONLY', 'PAID_PARTIAL', 'NOT_TRANSFERRED' ),
    amountReceived : '', // Actual amount received by CuDel
    isPayoutEligible : false, // Whether expert qualifies for payout
    referenceNumber : '',
    customerFeedback : '',
    paidBalanceAmount : '', // Balance after payment (negative = adjustment, positive = tip/adjustment
    tipAdjustmentType : 'NONE', // ENUM('NONE', 'TIP', 'ADJUSTMENT')
    paymentRemarks : '',

  }
  const [bookingPaymentData, setBookingPaymentData] = useState(initialState);
  const {control,handleSubmit,watch,setValue,reset,formState: { errors ,isDirty}} = useForm({
    mode:"onChange",
    defaultValues:bookingPaymentData
  });

  /*================== image upload realted ====================== */
  const [imageUploadResponseDetails, setImageUploadResponseDetails] = useState({});
  const [imgModalOpen, setImgModalOpen] = useState(false);

  const openImgModal = () => {
      setImgModalOpen(true);
  };

  const closeModal = () => {
      setImgModalOpen(false);
  };

  const imgData = {
      path: 'booking-payment',
      img_type: "single"
  };
  const imgUploadResponse = (data) => {
      setImageUploadResponseDetails(data);
      setValue('image', data.imageName, { shouldDirty: true, shouldValidate: true });
  }
  
  const paymentMethod = watch('paymentMethod');  
  const customerPaidAmount = watch('customerPaidAmount');
  const bookingBalanceAmount = watch('bookingBalanceAmount');
  const expertPaymentStatus = watch('expertPaymentStatus');
  const cudelReceivedAmount = watch('amountReceived') 
  

  useEffect(()=>{
    if(paymentMethod == 'APP_RAZORPAY'){
      setValue('expertPaymentStatus','TRANSFERRED_FULL');
      setValue('amountReceived',bookingBalanceAmount);
      setValue('isPayoutEligible',true);
      setValue('customerPaidAmount',bookingBalanceAmount);
    }
  },[paymentMethod])
  
  // useEffect(()=>{
  //   if(customerPaidAmount && bookingBalanceAmount){
  //     setValue('paidBalanceAmount',parseFloat(customerPaidAmount)-parseFloat(bookingBalanceAmount));
  //     if(expertPaymentStatus == 'TRANSFERRED_FULL'){
  //       setValue('amountReceived',customerPaidAmount);
  //     }
  //   }
  // },[customerPaidAmount,bookingBalanceAmount]);
  useEffect(()=>{
    if(customerPaidAmount && bookingBalanceAmount){
      setValue('paidBalanceAmount',parseFloat(cudelReceivedAmount)-parseFloat(bookingBalanceAmount));
      if(expertPaymentStatus == 'TRANSFERRED_FULL'){
        setValue('amountReceived',customerPaidAmount);
      }
    }
  },[customerPaidAmount,bookingBalanceAmount,cudelReceivedAmount]);

  const paidBalanceAmount = watch('paidBalanceAmount');
  useEffect(()=>{
    if(paidBalanceAmount<0){
      setValue('tipAdjustmentType','ADJUSTMENT');
    } else if(paidBalanceAmount == 0){
      setValue('tipAdjustmentType','NONE');
    }
  },[paidBalanceAmount]);
  useEffect(()=>{
    if(expertPaymentStatus == 'NOT_TRANSFERRED' || expertPaymentStatus == 'PAID_FEES_ONLY'){
      setValue('isPayoutEligible',false);
      setValue('amountReceived','0');
    }else if(expertPaymentStatus == 'TRANSFERRED_FULL'){
      setValue('amountReceived',customerPaidAmount);      
      setValue('isPayoutEligible',true);
    }
    else{
      setValue('isPayoutEligible',true);
    }
  },[expertPaymentStatus]);

  const handleFormSubmission = async (data)=>{
    console.log(" submitted form data:",data);
    const {bookingNumber,bookingAmount,...restAll} = data;
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Save it!',
      cancelButtonText: 'No, cancel',
      allowOutsideClick: false,
    })
    if(!result.isConfirmed){
      return;
    }
    Swal.fire({
      title: 'Please Wait...',
      showConfirmButton: false, 
      allowOutsideClick: false,
      allowEscapeKey: false,
      willOpen: () => {
        Swal.showLoading()
      },  
    })
    const createResponse = await PaymentServices.createPaymentRecord(restAll);
    if(createResponse.success=='1'){
      Swal.fire({
        title: 'Payment record added successfully',
        icon: 'success',
        showConfirmButton: false,
        timer: 1500
      });
      reset(initialState);
      setImageUploadResponseDetails({});
      closePaymentEntryDialog();
      fetchBookingDetalById();
    }
  }

  const [fetchingPendingAmount, setFetchingPendingAmount] = useState(false);
  const fetchPendingBookingAmount=async(bookingId)=>{
    console.log("booking id:",bookingId);
    setFetchingPendingAmount(true);
    const response = await PaymentServices.fetchPendingAmount(bookingId);
    if(response.success=='1'){
      console.log("last payment record:",response.data);
      if(response.data.pendingAmount > 0){     
        setValue('bookingBalanceAmount',response.data.pendingAmount);
      }else{
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'No Pending Balance Found for this Booking!',
          allowOutsideClick: false,
          // timer: 1500
        }).then((result) => {
          if (result.isConfirmed) {
            reset(initialState);
            closePaymentEntryDialog();
          }
        })
      }
      setFetchingPendingAmount(false);
    }
  }
  useEffect(()=>{
    if(bookingDetails && bookingDetails.id){
      setValue('bookingId',bookingDetails.id);
      setValue('bookingNumber',bookingDetails.bookingNumber);
      setValue('bookingAmount',bookingDetails.total);
      fetchPendingBookingAmount(bookingDetails.id);
    }
  },[bookingDetails])

  return (
    <>
    <Box component={'form'} onSubmit={handleSubmit(handleFormSubmission)}>
      <Card sx={{p:2}}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4} md={3}>
            <Typography sx={{fontSize:'0.75rem',fontWeight:500}}>Booking Number</Typography>          
              <Box sx={{display:"flex",gap:1}}>
                <Controller
                  name='bookingNumber'
                  control={control}
                  rules={{
                    required:true,
                    pattern: {
                      // Format: Only digits and "BI" letters allowed
                      // Must contain "BI" with at least 1 digit before and after
                      // Example: 151025144909BI2760
                      value: /^\d+BI\d+$/,
                      message: 'Invalid Booking Number. Only digits and "BI" allowed. Format: [digits]BI[digits]'
                    }
                  }}
                  render={({field,fieldState:{error}})=>(
                    <TextField
                      {...field}
                      disabled
                      fullWidth
                      size='small'
                      error={!!error}
                      inputProps={{
                        style:{
                          fontSize:'0.65rem'
                        },
                      }}
                    />
                  )}
                />
              </Box>
          </Grid>
          <Grid item md={3} sx={{display:{xs:'none',md:'block'}}}/>
          <Grid item xs={12} sm={4} md={3}>
            <Typography sx={{fontSize:'0.75rem',fontWeight:500}}>Booking Amount</Typography>
            <Controller
              name='bookingAmount'
              control={control}
              rules={{required:true}}
              defaultValue='0'
              render={({field,fieldState:{error}})=>(
                <TextField
                  {...field}
                  fullWidth
                  size='small'
                  error={!!error}
                  inputProps={{
                    style:{
                      fontSize:'0.65rem'
                    },
                  }}
                  disabled
                />
              )}
            />
          </Grid>
          <Grid item xs={12} sm= {4} md={3}>
            <Typography sx={{fontSize:'0.75rem',fontWeight:500}}>Pending Balance Amount</Typography>
            <Box sx={{display:"flex",justifyContent:'center',alignItems:'center',gap:1}}>
              <Controller
                name='bookingBalanceAmount'
                control={control}
                rules={{required:true}}
                defaultValue='0'
                render={({field,fieldState:{error}})=>(
                  <TextField
                    {...field}
                    fullWidth
                    size='small'
                    error={!!error}
                    inputProps={{
                      style:{
                        fontSize:'0.65rem'
                      },
                    }}
                    disabled
                  />
                )}
              />
              {fetchingPendingAmount && <CircularProgress/>}
            </Box>
          </Grid>

          <Grid item xs={12} md={9}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4}>
                <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Payment Method <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                <Controller
                    control={control}
                    name="paymentMethod"
                    rules={{
                        required:'select Payment Method',
                    }}
                    render={({field,fieldState:{error}})=>(
                        <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                            <Select
                                {...field}
                                error={!!error}
                                sx={{
                                    fontSize:'0.65rem',
                                }}
                            >
                              <MenuItem value='CASH' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>CASH</MenuItem>
                              <MenuItem value='UPI_QR' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>UPI-QR</MenuItem>
                              <MenuItem value='APP_RAZORPAY' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>APP-Razorpay</MenuItem>
                            </Select>
                        </FormControl>
                    )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                  <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>Expert Payment to Cudel Status <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                  <Controller
                      control={control}
                      name="expertPaymentStatus"
                      rules={{
                          required:'select expert Payment Status',
                      }}
                      render={({field,fieldState:{error}})=>(
                          <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                              <Select
                                  {...field}
                                  error={!!error}
                                  sx={{
                                      fontSize:'0.65rem',
                                  }}
                                  disabled={paymentMethod== 'APP_RAZORPAY' ? true : false}
                              >
                                <MenuItem value='TRANSFERRED_FULL' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Full Amount Transferred to CuDel</MenuItem>
                                <MenuItem value='PAID_FEES_ONLY' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Paid Fess Only</MenuItem>
                                <MenuItem value='PAID_PARTIAL' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Paid Partially</MenuItem>
                                <MenuItem value='NOT_TRANSFERRED' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Not Transferred</MenuItem>
                              </Select>
                          </FormControl>
                      )}
                  />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Reference Number </Typography>
                <Controller
                  name='referenceNumber'
                  control={control}
                  rules={{ 
                    validate: (value) => {
                      if(value){
                        const words = value?.trim().split(/\s+/);
                        if (words.length > 100) {
                          return 'Please enter a description with 100 words or less';
                        }
                      }
                      return true;
                    }
                  }}
                  render={({ field, fieldState: { error } }) => (
                    <TextField
                      {...field}
                      size='small'
                      fullWidth
                      inputProps={{
                        style: { fontSize: '0.65rem' },
                      }}
                      error={!!error}
                      helperText={error?.message}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>customer Paid Amount (in Rs.)<span style={{ color: '#d32f2f' }}>*</span></Typography>
                <Controller
                    name='customerPaidAmount'
                    control={control}
                    rules={{
                        required: "Enter customer Paid Amount",
                        validate: (value) => {
                            const floatValue = parseFloat(value);
                            if (isNaN(floatValue)) return 'Please enter a valid number';
                            // if (floatValue > 1000) return 'visiting charge should not exceed ₹1,000';
                            if (floatValue > 0 && floatValue < 1) return 'visiting charge should not be less than ₹1';
                            return floatValue >= 0 || 'visiting charge should not be negative';
                        }
                    }}
                    defaultValue={0}
                    render={({ field, fieldState: { error } }) => (
                        <TextField
                            {...field}
                            placeholder='0'
                            fullWidth
                            type="number"
                            disabled={paymentMethod == 'APP_RAZORPAY'}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              let finalValue;
                              if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {                                
                                finalValue = formatValue(inputValue);
                                if(finalValue==''){
                                    finalValue=0
                                }

                                field.onChange(finalValue);
                              }
                            }}
                            inputMode="decimal"
                            size="small"
                            inputProps={{
                                style: { textAlign: 'center', height: '1rem', fontSize: '0.75rem' },
                                min: 0,
                                max: 10000,
                                step: 0.01, // Allow two decimal places
                                onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused
                                onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                onKeyDown: (e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault();
                                    }
                                }
                            }}
                            error={!!error}
                        />
                    )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>Cudel Amount Received (in Rs.)<span style={{ color: '#d32f2f' }}>*</span></Typography>
                <Controller
                    name='amountReceived'
                    control={control}
                    rules={{
                        required: "Enter Cudel Amount Received",
                        validate: (value) => {
                            const floatValue = parseFloat(value);
                            if (isNaN(floatValue)) return 'Please enter a valid number';
                            // if (floatValue > 1000) return 'visiting charge should not exceed ₹1,000';
                            if (floatValue > 0 && floatValue < 1) return 'visiting charge should not be less than ₹1';
                            return floatValue >= 0 || 'visiting charge should not be negative';
                        }
                    }}
                    defaultValue={0}
                    render={({ field, fieldState: { error } }) => (
                        <TextField
                            {...field}
                            placeholder='0'
                            fullWidth
                            type="number"                      
                            disabled={paymentMethod == 'APP_RAZORPAY' || expertPaymentStatus == 'TRANSFERRED_FULL' || expertPaymentStatus == 'NOT_TRANSFERRED'}
                            onChange={(e) => {
                              const inputValue = e.target.value;
                              let finalValue;
                              if (inputValue === '' || /^\d*\.?\d*$/.test(inputValue)) {                                
                                finalValue = formatValue(inputValue);
                                if(finalValue==''){
                                    finalValue=0
                                }

                                field.onChange(finalValue);
                              }
                            }}
                            inputMode="decimal"
                            size="small"
                            inputProps={{
                                style: { textAlign: 'center', height: '1rem', fontSize: '0.75rem' },
                                min: 0,
                                max: 10000,
                                step: 0.01, // Allow two decimal places
                                onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused
                                onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                onKeyDown: (e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault();
                                    }
                                }
                            }}
                            error={!!error}
                        />
                    )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography sx={{ fontWeight: '600', fontSize: '0.75rem' }}>Paid Balance Amount (in Rs.)<span style={{ color: '#d32f2f' }}>*</span></Typography>
                <Controller
                    name='paidBalanceAmount'
                    control={control}
                    // rules={{
                    //     // required: "Enter Cudel Amount Received",
                    //     validate: (value) => {
                    //         const floatValue = parseFloat(value);
                    //         if (isNaN(floatValue)) return 'Please enter a valid number';
                    //         // if (floatValue > 1000) return 'visiting charge should not exceed ₹1,000';
                    //         if (floatValue > 0 && floatValue < 1) return 'visiting charge should not be less than ₹1';
                    //         return floatValue >= 0 || 'visiting charge should not be negative';
                    //     }
                    // }}
                    defaultValue={0}
                    render={({ field, fieldState: { error } }) => (
                        <TextField
                            {...field}
                            placeholder='0'
                            fullWidth
                            type="number"
                            disabled
                            inputMode="decimal"
                            size="small"
                            value={parseFloat(field.value).toFixed(2)}
                            inputProps={{
                                style: { textAlign: 'center', height: '1rem', fontSize: '0.75rem' },
                                min: 0,
                                max: 10000,
                                step: 0.01, // Allow two decimal places
                                onFocus: (e) => e.target.select(), // This will auto-select all text on focus/click
                                onClick: (e) => e.target.select(),  // This ensures selection even on click when already focused
                                onWheel: (e) => e.target.blur(),  // Prevent scroll wheel
                                onKeyDown: (e) => {
                                    if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
                                        e.preventDefault();
                                    }
                                }
                            }}
                            error={!!error}
                        />
                    )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <Typography sx={{fontSize:'0.75rem',fontWeight:600}}>Tip/Adjustment Type <Box component='span' sx={{color:'#d32f2f'}}>*</Box></Typography>
                <Controller
                    control={control}
                    name="tipAdjustmentType"
                    rules={{
                        required:'select expert Payment Status',
                    }}
                    render={({field,fieldState:{error}})=>(
                        <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                            <Select
                              {...field}
                              error={!!error}
                              sx={{
                                  fontSize:'0.65rem',
                              }}
                              disabled={paidBalanceAmount== 0 || paidBalanceAmount<0}
                            >
                              {paidBalanceAmount== 0 && <MenuItem value='NONE' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>None</MenuItem>}
                              <MenuItem value='TIP' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Tip</MenuItem>
                              <MenuItem value='ADJUSTMENT' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Adjustment</MenuItem>
                            </Select>
                        </FormControl>
                    )}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Payout Eligiblity </Typography>
              <Controller
                  control={control}
                  name="isPayoutEligible"
                  rules={{
                      required:'select Payment Method',
                  }}
                  render={({field,fieldState:{error}})=>(
                      <FormControl sx={{ minWidth: "100%" }} size="small">                                            
                          <Select
                              {...field}
                              error={!!error}
                              sx={{
                                  fontSize:'0.65rem',
                              }}
                          >
                            <MenuItem value='true' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Eligible</MenuItem>
                            <MenuItem value='false' sx={{textTransform:'capitalize',fontSize:'0.65rem'}}>Not Eligible</MenuItem>
                          </Select>
                      </FormControl>
                  )}
              />
              {/* <Controller
                name='isPayoutEligible'
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    size='small'
                    fullWidth
                    inputProps={{
                      style: { fontSize: '0.65rem',textTransform:'capitalize' },
                    }}
                    error={!!error}
                    // disabled

                  />
                )}
              /> */}
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Payment Remarks </Typography>
              <Controller
                name='paymentRemarks'
                control={control}
                rules={{ 
                  validate: (value) => {
                    if(value){
                      const words = value?.trim().split(/\s+/);
                      if (words.length > 25) {
                        return 'Please enter a Payment Remarks with 25 words or less';
                      }
                    }
                    return true;
                  }
                }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    size='small'
                    fullWidth
                    multiline
                    // rows={3}
                    inputProps={{
                      style: { fontSize: '0.65rem' },
                    }}
                    error={!!error}
                    placeholder='.... upto 25 words only'
                    helperText={error?.message}
                  />
                )}
              />
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ fontWeight: '600', display: 'flex ', alignItems: 'center', fontSize: '.75rem' }}>Customer Feedback </Typography>
              <Controller
                name='customerFeedback'
                control={control}
                rules={{ 
                  validate: (value) => {
                    if(value){
                      const words = value?.trim().split(/\s+/);
                      if (words.length > 25) {
                        return 'Please enter a Customer Feedback with 25 words or less';
                      }
                    }
                    return true;
                  }
                }}
                render={({ field, fieldState: { error } }) => (
                  <TextField
                    {...field}
                    size='small'
                    fullWidth
                    multiline
                    // rows={3}
                    inputProps={{
                      style: { fontSize: '0.65rem' },
                    }}
                    error={!!error}
                    placeholder='.... upto 25 words only'
                    helperText={error?.message}
                  />
                )}
              />
            </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={3}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography sx={{fontSize:'0.85rem',fontWeight:600}}>
                  Image <Box component="span" sx={{ color: 'error.main' }}>{paymentMethod!== 'APP_RAZORPAY' &&paymentMethod!== 'CASH' && '*'}</Box>
                </Typography>

                <Box sx={{ textAlign: 'center'}}>
                    <Box sx={{height: '11rem',border:'1px dashed gray',borderRadius:'4px',mb:1}}>

                    
                        {(imageUploadResponseDetails.imageName || bookingPaymentData.image) && (
                            <Box sx={{ mb: 2, justifyContent: 'center', boxShadow: '0 0 5px rgba(0,0,0,0.1)' ,height:'100%',display:'flex',alignItems:'center'}}>
                                <img
                                    src={`${Helpers.ImagePathUrl()}/booking-payment/${imageUploadResponseDetails.imageName || bookingPaymentData.image}`}
                                    alt="Service"
                                    style={{ maxWidth: '100%' ,maxHeight:'100%' }}
                                />
                            </Box>
                        )}
                    </Box>

                    <Button
                        onClick={openImgModal}
                        // disabled={isSubmitting}
                        variant="outlined"
                        startIcon={<AddToPhotos />}
                        size="small"
                        fullWidth
                    >
                        {imageUploadResponseDetails.imageName || bookingPaymentData.image ? 'Change Image' : 'Select Image'}
                    </Button>
                </Box>

                <Controller
                    control={control}
                    name='image'
                    rules={{
                      required:( paymentMethod!== 'APP_RAZORPAY' && paymentMethod!== 'CASH') && 'Please upload an image' 
                    }}
                    render={({ fieldState: { error } }) => (
                        error && (
                            <Typography color="error" variant="caption" display="block" textAlign="center">
                                {error.message}
                            </Typography>
                        )
                    )}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{display:'flex',justifyContent:'center',gap:'1%'}}>
            <Button disabled={!isDirty} size='small' type='submit' variant='contained' color='primary' sx={{textTransform:'capitalize'}}>Submit</Button>
            <Button size='small' variant='contained' color='error' sx={{textTransform:'capitalize'}}
              onClick={()=>{
                reset(initialState);
                closePaymentEntryDialog();
              }}
            >Cancel</Button>
          </Grid>
        </Grid> 
      </Card>
    </Box>
     
    {/* ============== image upload dialog ============= */}
    <ImgUploadDialog open={imgModalOpen} onClose={closeModal}
        imgData={imgData}
        imgUploadResponse={imgUploadResponse}
    /> 
    </>
  )
}

export default AddPaymentRecord
const formatValue = (value) => {
    if (!value) return '';  // Return empty string instead of 0
    const numValue = parseFloat(value);
    return isNaN(numValue) ? '' : numValue.toString();
};